import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import PageHero from '@/components/feature/PageHero';
import Reveal from '@/components/base/Reveal';
import Positioning from '@/pages/zhongxian-commerce/components/Positioning';
import FunctionFramework from '@/pages/zhongxian-commerce/components/FunctionFramework';
import ModuleExplorer from '@/pages/zhongxian-commerce/components/ModuleExplorer';
import BusinessFlows from '@/pages/zhongxian-commerce/components/BusinessFlows';
import SystemRoles from '@/pages/zhongxian-commerce/components/SystemRoles';
import { zxHero, zxRelated } from '@/mocks/zhongxian-commerce';

export default function ZhongxianCommerce() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="中仙数智商贸｜县域数字商贸平台｜客户案例｜华辉数智"
        description="中仙数智商贸以「尤溪 ePin 云铺」为业务指挥中心、以数字人民币智能合约为结算底座，构建覆盖农产品生产、品控溯源、市场经营、线上销售、仓储履约、消费激励与县域运营的数据化商贸平台。"
        keywords="中仙数智商贸,县域数字商贸,ePin食安码,数字人民币,农产品溯源,智能分账"
        path="/cases/zhongxian-farm-market"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: '中仙数智商贸：县域数智商贸平台',
          description:
            '覆盖平台定位、网站导航框架、产品功能框架、功能模块与具体功能、核心业务流程与系统角色的县域数智商贸平台。',
          articleSection: '客户案例',
        }}
      />

      <PageHero
        eyebrow={zxHero.eyebrow}
        title={zxHero.title}
        titleHighlight={zxHero.titleHighlight}
        subtitle={zxHero.subtitle}
        desc={zxHero.desc}
        imageUrl={zxHero.imageUrl}
        imageAlt={zxHero.imageAlt}
        imageTitle="中仙数智商贸"
      />

      <Breadcrumb items={[{ label: '客户案例', href: '/cases' }, { label: '中仙数智商贸' }]} />

      <main>
        <Positioning />
        <FunctionFramework />
        <ModuleExplorer />
        <BusinessFlows />
        <SystemRoles />

        {/* 相关解决方案 */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Reveal>
              <div className="p-6 md:p-8 rounded-lg bg-secondary-100/70 border border-secondary-200">
                <h2 className="text-sm font-semibold tracking-widest text-secondary-900 uppercase">相关解决方案</h2>
                <div className="mt-4 flex flex-wrap gap-2">
                  {zxRelated.solutions.map((s) => (
                    <Link
                      key={s.label}
                      to={s.href}
                      className="px-4 py-2 rounded-md bg-background-50 border border-background-200 text-sm text-foreground-700 whitespace-nowrap cursor-pointer transition-colors hover:border-primary-300 hover:text-primary-600"
                    >
                      {s.label}
                    </Link>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}